import React, { useState } from "react";
import { X } from "lucide-react";

export default function StudentListModal({ studentIds, studentNames, onConfirm, onClose }) {
  const [localIds, setLocalIds] = useState([...studentIds]);
  const [localNames, setLocalNames] = useState({ ...studentNames });

  function handleRemove(id) {
    setLocalIds((current) => current.filter((sid) => sid !== id));
    setLocalNames((current) => {
      const next = { ...current };
      delete next[id];
      return next;
    });
  }

  function handleConfirm() {
    onConfirm(localIds, localNames);
    onClose();
  }

  return (
    <div
      className="teacher-mocks-picker-overlay"
      onMouseDown={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Lista de alunos"
    >
      <div
        className="teacher-mocks-picker-modal"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="teacher-mocks-picker-header">
          <h3>Lista de Alunos ({localIds.length})</h3>
          <button
            type="button"
            className="teacher-mocks-icon-button"
            onClick={onClose}
            aria-label="Fechar"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>

        <div className="teacher-mocks-picker-body">
          <div className="teacher-mocks-student-results teacher-mocks-student-results--scrollable" role="list" aria-label="Alunos selecionados">
            {localIds.length === 0 && (
              <div className="teacher-mocks-student-empty">Nenhum aluno na lista.</div>
            )}
            {localIds.map((id) => (
              <div key={id} className="teacher-mocks-student-result-item" role="listitem">
                <div className="teacher-mocks-student-info">
                  <span className="teacher-mocks-student-name">{localNames[id] || `Aluno #${id}`}</span>
                </div>
                <button
                  type="button"
                  className="teacher-mocks-student-remove-btn"
                  aria-label={`Remover ${localNames[id] || `Aluno #${id}`}`}
                  onClick={() => handleRemove(id)}
                >
                  Remover
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="teacher-mocks-picker-footer">
          <button type="button" className="teacher-mocks-picker-cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="teacher-mocks-picker-confirm-btn" onClick={handleConfirm}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
